<template>
  <div>
    <div class="d-flex justify-space-between">
      <div class="flex-1">
        <div class="text-4 font-weight-medium">Your Balance</div>
        <div class="mt-4 d-flex align-center justify-end text-5 px-md-6">
          <div>Total Assets:</div>
          <div class="ml-5 mt-0 d-flex align-baseline">
            <div>
              {{
                totalAssets
                  | denomConverter(currentProject.staking)
                  | denomFormat
              }}
            </div>
            <div class="darkgray--text text-6 ml-1 text-uppercase">
              {{ currentProject.staking.token }}
            </div>
            <v-divider vertical class="border-secondary ml-5 mr-5"></v-divider>
            <div>${{ totalAssetsUsd | currency }}</div>
            <div class="darkgray--text text-6 ml-1 text-uppercase">usd</div>
          </div>
        </div>
        <div class="mt-4">
          <div
            class="d-flex align-center bg-stake-lighter has-border border-stake rounded-8 gray--text text-6 font-weight-medium px-2 px-md-6 py-2"
          >
            <div class="flex-2">Available</div>
            <div class="flex-3 text-right">Unbonding</div>
            <div class="flex-3 text-right">Withdrawable</div>
          </div>
          <div class="mt-4 d-flex align-center px-2 px-md-6 text-5">
            <div class="flex-2 text-uppercase">
              <div>
                <span>
                  {{
                    availableBalance
                      | denomConverter(currentProject.staking)
                      | denomFormat
                  }}</span
                >
                <span class="darkgray--text text-6">
                  {{ currentProject.staking.token }}</span
                >
              </div>
              <div class="mt-1 text-6 darkgray--text">
                <span class="font-weight-medium"
                  >${{
                    (getTokenPriceInUsd(currentProject.staking.token) *
                      availableBalance)
                      | denomConverter(currentProject.staking)
                      | currency
                  }}</span
                >
                <span class="ml-1">USD</span>
              </div>
            </div>
            <div class="flex-3 text-right text-uppercase">
              <div>
                <span>
                  {{
                    unbondingBalance
                      | denomConverter(currentProject.staking)
                      | denomFormat
                  }}</span
                >
                <span class="darkgray--text text-6">
                  {{ currentProject.staking.token }}</span
                >
              </div>
              <div class="text-right mt-1 text-6 darkgray--text">
                <span class="font-weight-medium"
                  >${{
                    (getTokenPriceInUsd(currentProject.staking.token) *
                      unbondingBalance)
                      | denomConverter(currentProject.staking)
                      | currency
                  }}</span
                >
                <span class="ml-1">USD</span>
              </div>
            </div>
            <div class="flex-3 text-right text-uppercase">
              N/A
            </div>
          </div>
        </div>
        <div class="mt-4">
          <div
            class="d-flex align-center bg-stake-lighter has-border border-stake rounded-8 gray--text text-6 font-weight-medium px-2 px-md-6 py-2"
          >
            <div class="flex-2">Total Staked</div>
            <div class="flex-3 text-right">Locked Rewards</div>
            <div class="flex-3 text-right">Claimable Rewards</div>
          </div>
          <div class="mt-4 d-flex align-center px-2 px-md-6 text-5">
            <div class="flex-2 text-uppercase">
              <div>
                <span>
                  {{
                    stakedBalance
                      | denomConverter(currentProject.staking)
                      | denomFormat
                  }}</span
                >
                <span class="darkgray--text text-6">
                  {{ currentProject.staking.token }}</span
                >
              </div>
              <div class="mt-1 text-6 darkgray--text">
                <span class="font-weight-medium"
                  >${{
                    (getTokenPriceInUsd(currentProject.staking.token) *
                      stakedBalance)
                      | denomConverter(currentProject.staking)
                      | currency
                  }}</span
                >
                <span class="ml-1">USD</span>
              </div>
            </div>
            <div class="flex-3 text-right text-uppercase">
              N/A
            </div>
            <div class="flex-3 text-right text-uppercase">
              <div v-if="!currentProject.staking.rewards">
                <div>
                  <span>
                    {{
                      rewardBalance
                        | denomConverter(currentProject.staking)
                        | denomFormat
                    }}</span
                  >
                  <span class="darkgray--text text-6">
                    {{ currentProject.staking.token }}</span
                  >
                </div>
                <div class="text-right mt-1 text-6 darkgray--text">
                  <span class="font-weight-medium"
                    >${{
                      (getTokenPriceInUsd(currentProject.staking.token) *
                        rewardBalance)
                        | denomConverter(currentProject.staking)
                        | currency
                    }}</span
                  >
                  <span class="ml-1">USD</span>
                </div>
              </div>
              <div v-else>
                <div class="mb-3" v-for="reward in currentProject.staking.rewards">
                  <div>
                    <span>
                      {{
                        allDenomRewards[reward.denom]
                          | denomConverter(currentProject.staking, { conversionRate: reward.decimal })
                          | denomFormat
                      }}</span
                    >
                    <span class="darkgray--text text-6">
                      {{ reward.display }}</span
                    >
                  </div>
                  <div v-if="reward.isNative" class="text-right mt-1 text-6 darkgray--text">
                    <span class="font-weight-medium"
                      >${{
                        (getTokenPriceInUsd(currentProject.staking.token) *
                          allDenomRewards[reward.denom])
                          | denomConverter(currentProject.staking)
                          | currency
                      }}</span
                    >
                    <span class="ml-1">USD</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-10" v-if="delegations.length > 0">
          <div class="text-4">Delegations</div>
          <div
            class="mt-4 d-flex align-center bg-stake-lighter has-border border-stake rounded-8 gray--text text-6 font-weight-medium px-2 px-md-6 py-2"
          >
            <div class="flex-2">Amount</div>
            <div class="flex-3 text-right">Validator</div>
            <div class="flex-3 text-right">Reward</div>
          </div>
          <div
            class="mt-4 d-flex align-center px-2 px-md-6 text-5"
            v-for="item in delegations"
            :key="item.validator"
          >
            <div class="flex-2">
              <span>
                {{
                  item.amount
                    | denomConverter(currentProject.staking)
                    | denomFormat
                }}</span
              >
              <span class="darkgray--text text-6 text-uppercase">
                {{ currentProject.staking.token }}</span
              >
            </div>
            <div
              class="flex-3 validator-addr text-right"
              :title="item.validatorAddr"
            >
              {{ item.validator }}
            </div>
            <div class="flex-3 text-right">
              <div v-for="reward in currentProject.staking.rewards">
                <span>
                  {{
                    item.rewards && item.rewards[reward.denom]
                      | denomConverter(currentProject.staking)
                      | denomFormat
                  }}</span
                >
                <span class="darkgray--text text-6 text-uppercase">
                  {{ reward.display }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="mt-10" v-if="unbondings.length > 0">
          <div class="text-4">Unbondings</div>
          <div
            class="mt-4 d-flex align-center bg-stake-lighter has-border border-stake rounded-8 gray--text text-6 font-weight-medium px-2 px-md-6 py-2"
          >
            <div class="flex-2">Validator</div>
            <div class="flex-1 text-right">Amount</div>
            <div class="flex-1 text-right">Completion Time</div>
          </div>
          <div
            class="mt-4 d-flex align-center px-2 px-md-6 text-5"
            v-for="item in unbondings"
            :key="item.validator.moniker"
          >
            <div class="flex-2">{{ item.validator.moniker }}</div>
            <div class="flex-1 text-right">
              <span>
                {{
                  item.balance
                    | denomConverter(currentProject.staking)
                    | denomFormat
                }}</span
              >
              <span class="darkgray--text text-6 text-uppercase">
                {{ currentProject.staking.token }}</span
              >
            </div>
            <div class="flex-1 text-right">
              {{ new Date(item.endsOn) | datetime }}
            </div>
          </div>
        </div>
        <div>
          <osmosis-lp-autocompound v-if="currentProject.name === 'osmosis'" />
        </div>
      </div>
      <div class="ml-12 d-none d-md-block" style="width:160px">
        <div
          class="d-flex align-center justify-space-between"
          v-if="enableRestakeAvailable || disableRestakeAvailable"
        >
          <div class="d-flex align-center mb-6">
            <img
              src="@/assets/icons/restake.svg"
              height="20"
              width="20"
              alt=""
            />
            <div class="ml-2 text-6 font-weight-medium gray--text">REStake</div>
            <v-tooltip bottom color="dark" max-width="260px">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="gray--text ml-1" v-bind="attrs" v-on="on"
                  >mdi-information</v-icon
                >
              </template>
              Enabling ReStake authorizes the Stakewithus validator to send
              delegate transactions on your behalf to auto-compound your rewards
              for one year. You may revoke this authorization at any time.
              <br /><br />
              REStake is a fully open source service and transaction fees are
              absorbed by the validator.
            </v-tooltip>
            <v-switch
              :value="disableRestakeAvailable"
              class="mr-0 ml-5 mt-0 pt-0 restake-switch"
              hide-details
              inset
              dense
              readonly
              @click.stop="restake"
            ></v-switch>
          </div>
        </div>
        <div>
          <c-btn v-if="!currentProject.isLegacy" class="width-100" @click="goToTx('stake')" walletRequired
            >Stake</c-btn
          >
        </div>
        <div>
          <c-btn
            class="width-100 mt-4"
            is-secondary
            @click="goToTx('claim')"
            walletRequired
            >Claim</c-btn
          >
        </div>
        <div>
          <c-btn
            class="width-100 mt-4"
            is-secondary
            @click="goToTx('unstake')"
            walletRequired
            >Unstake</c-btn
          >
        </div>
        <div>
          <c-btn
            class="width-100 mt-4"
            is-secondary
            @click="goToTx('redelegate')"
            walletRequired
            >Redelegate</c-btn
          >
        </div>
      </div>
    </div>
    <div class="mt-10 d-block d-md-none">
      <div
        class="d-flex align-center justify-end"
        v-if="enableRestakeAvailable || disableRestakeAvailable"
      >
        <div class="d-flex align-center mb-6">
          <img src="@/assets/icons/restake.svg" height="20" width="20" alt="" />
          <div class="ml-2 text-6 font-weight-medium gray--text">REStake</div>
          <v-tooltip bottom color="dark" max-width="260px">
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="gray--text ml-1" v-bind="attrs" v-on="on"
                >mdi-information</v-icon
              >
            </template>
            Enabling ReStake authorizes the Stakewithus validator to send
            delegate transactions on your behalf to auto-compound your rewards
            for one year. You may revoke this authorization at any time.
            <br /><br />
            REStake is a fully open source service and transaction fees are
            absorbed by the validator.
          </v-tooltip>
          <v-switch
            :value="disableRestakeAvailable"
            class="mr-0 ml-5 mt-0 pt-0 restake-switch"
            hide-details
            inset
            dense
            readonly
            @click.stop="restake"
          ></v-switch>
        </div>
      </div>
      <div>
        <c-btn v-if="!currentProject.isLegacy" class="width-100" @click="goToTx('stake')" walletRequired
          >Stake</c-btn
        >
      </div>
      <div>
        <c-btn
          class="width-100 mt-4"
          is-secondary
          @click="goToTx('claim')"
          walletRequired
          >Claim</c-btn
        >
      </div>
      <div>
        <c-btn
          class="width-100 mt-4"
          is-secondary
          @click="goToTx('unstake')"
          walletRequired
          >Unstake</c-btn
        >
      </div>
      <div>
        <c-btn
          class="width-100 mt-4"
          is-secondary
          @click="goToTx('redelegate')"
          walletRequired
          >Redelegate</c-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BN from "bignumber.js";
import OsmosisLpAutocompound from "./OsmosisLpAutocompound.vue";

export default {
  components: {
    OsmosisLpAutocompound,
  },
  computed: {
    ...mapGetters({
      accountInfo: "staking/tendermint/accountInfo",
      currentProject: "projectConfig/latestProject",
      unbonding: "staking/tendermint/unbonding",
      allStaked: "staking/tendermint/allStaked",
      rewards: "staking/tendermint/rewards",
      totalAssets: "staking/tendermint/totalAssets",
      getTokenPriceInUsd: "appConfig/getTokenPriceInUsd",
      blockInfo: "staking/tendermint/blockInfo",
      grants: "staking/tendermint/grants",
    }),
    availableBalance() {
      return this.accountInfo.result?.total || 0;
    },
    unbondingBalance() {
      return this.unbonding.result?.total || 0;
    },
    stakedBalance() {
      return this.allStaked.result?.total || 0;
    },
    rewardBalance() {
      return this.rewards.result?.total || 0;
    },
    allDenomRewards() {
      return this.rewards.result?.allDenomRewards || {};
    },
    delegations() {
      return (
        this.allStaked.result?.balances.map(item => ({
          validator: item.validator?.moniker || item.validator_address,
          validatorAddr: item.validator_address,
          amount: item.balance,
          rewards: this.rewards.result?.allDenomRewards,
          reward:
            this.rewards.result?.balances.find(
              r => r.validatorAddr === item.validator_address
            )?.balance ?? 0,
        })) ?? []
      );
    },
    unbondings() {
      return this.unbonding.result?.balances || [];
    },
    totalAssetsUsd() {
      return new BN(this.getTokenPriceInUsd(this.currentProject.staking.token))
        .multipliedBy(this.totalAssets)
        .dividedBy(this.currentProject.staking.conversionRate)
        .valueOf();
    },
    isGrantValid() {
      if (Number(this.grants.result?.grants?.length || 0) === 0) return false;
      const stakeGrant = this.grants.result?.grants.find(
        item =>
          item.authorization?.["@type"] ===
          "/cosmos.staking.v1beta1.StakeAuthorization"
      );
      if (!stakeGrant) return false;
      return new Date(stakeGrant.expiration).valueOf() > new Date().valueOf();
    },
    enableRestakeAvailable() {
      return (
        this.blockInfo.result?.autoCompoundBotAddress && !this.isGrantValid
      );
    },
    disableRestakeAvailable() {
      return this.blockInfo.result?.autoCompoundBotAddress && this.isGrantValid;
    },
  },
  methods: {
    goToTx(type) {
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: { type, action: "tx" },
      });
    },
    restake() {
      if (this.enableRestakeAvailable) {
        this.goToTx("enableRestake");
      } else {
        this.goToTx("disableRestake");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.validator-addr {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.restake-switch {
  .v-input--switch__track {
    color: transparent !important;
    border: 1px solid var(--black) !important;
    left: -4px !important;
  }
  .v-input--switch__thumb {
    color: var(--v-primary-base) !important;
    width: 16px !important;
    height: 16px !important;
    top: calc(50% - 9px) !important;
  }
  .v-input--selection-controls__ripple {
    left: -11px !important;
    top: calc(50% - 20px) !important;
    width: 24px !important;
    height: 24px !important;
    color: var(--v-primary-base) !important;
  }
}
</style>
